export class MngBaseModelRegistry<T> {
  private items: { [type: string]: T } = {};

  private defaultItem: T;

  setDefaultItem(item: T) {
    this.defaultItem = item;
  }

  getDefaultItem() {
    return this.defaultItem;
  }

  hasItemForKey(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.items, key);
  }

  register(type: string, item: T): this {
    this.items[type] = item;
    return this;
  }

  registerForTypes(types: string[], item: T): this {
    types.forEach((type) => this.register(type, item));
    return this;
  }

  getItemForKey(key: string): T {
    if (this.hasItemForKey(key)) {
      return this.items[key];
    }
    return this.defaultItem;
  }
}
